import { pdf } from "@react-pdf/renderer";
import toast from "react-hot-toast";
import CommissionSheetPDF from "../../components/CommissionAndRepayment/CommissionSheetPDF";
import { BankDetails } from "../../models/epcCustomer.model";

export interface CommissionPDFData {
  customerName: string;
  commissionId: string;
  commissionAmount: number;
  calculatedCommission: number;
  customCommission?: number;
  plantSize: string;
  confirmAt: string | undefined;
  status: string;
  excessAmount?: number;
  commissionValue?: number;
  adjustmentAmount?: number;
  materialDeduction?: number;
}

export const generateCommissionPDF = async (
  commissionData: CommissionPDFData[],
  user?: string,
  salesRepName?: string,
  panNumber?: string,
  bankDetails?: BankDetails,
): Promise<void> => {
  try {
    if (commissionData.length === 0) {
      toast.error("No commission data to generate PDF");
      return;
    }
    if (bankDetails) {
      const { bankAccountName, bankAccountNumber, ifsc } = bankDetails;
      if (!bankAccountName || !bankAccountNumber || !ifsc) {
        toast.error("Incomplete bank details. Please check bank information.");
        return;
      }
    }

    const generatedDate = new Date().toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const pdfDocument = (
      <CommissionSheetPDF
        commissionItems={commissionData}
        generatedDate={generatedDate}
        user={user}
        salesRepName={salesRepName}
        panNumber={panNumber}
        bankDetails={bankDetails}
      />
    );

    const pdfBlob = await pdf(pdfDocument).toBlob();
    const url = URL.createObjectURL(pdfBlob);

    // Also create a download link
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = `${salesRepName}-CS-${new Date().toISOString().split("T")[0]}.pdf`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    toast.success("Commission sheet PDF generated successfully!");
  } catch (error) {
    console.error("Error generating commission PDF:", error);
    toast.error("Failed to generate commission sheet PDF");
  }
};
